import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { actions } from 'builder/modules/panel'
import { DocumentTypes } from 'builder/modules/constants'
import { ResumeCraftingActionsProps } from '../types'
import { Service } from '../../../../types'

export const useResumeCraftingActions = (service: Service): ResumeCraftingActionsProps => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleNoResumeClick = () => {
    dispatch(actions.createDocument({ type: DocumentTypes.resume }))
  }

  const handleCompletedClick = () => {
    navigate(service.getNextActionUrl())
  }

  const handleInProgressClick = (resumeId: number | undefined, suggestionKey?: string) => {
    if (!resumeId) return
    navigate(`resumes/${String(resumeId)}/edit#${suggestionKey}`)
  }

  return {
    handleNoResumeClick,
    handleCompletedClick,
    handleInProgressClick,
  }
}
